
// Initial state
const state = {
  applicationVersion: localStorage.getItem('ApplicationVersion'),
  applicationVersionNew: '',
  runMode: '',
  numberOfCommandsInQueue: 0,
  oldestCommandTimestamp: null
}

// Mutations
const mutations = {
  setApplicationVersion (state, version) {
    state.applicationVersion = version
  },
  setApplicationVersionNew (state, version) {
    state.applicationVersionNew = version
  },
  setRunMode (state, runMode) {
    state.runMode = runMode
  },
  setNumberOfCommandsInQueue (state, no) {
    state.numberOfCommandsInQueue = no
  },
  setOldestCommandTimestamp (state, timestamp) {
    state.oldestCommandTimestamp = timestamp
  }
}

// Actions
const actions = {
  setApplicationVersion ({ commit, state }, version) {
    commit('setApplicationVersion', version)
    localStorage.setItem('ApplicationVersion', version)
  },
  setApplicationVersionNew ({ commit, state }, version) {
    commit('setApplicationVersionNew', version)
    localStorage.setItem('ApplicationVersionNew', version)
  },
  setRunMode ({ commit, state }, runMode) {
    commit('setRunMode', runMode)
  },
  updateContractorCommandStatus ({ commit, state }, ctx) {
    // console.log('Updating constractor status with ' + ctx.number + ' and ' + ctx.timestamp)
    commit('setNumberOfCommandsInQueue', ctx.number)
    commit('setOldestCommandTimestamp', ctx.timestamp)
  },
  upgradeApplication ({ commit, state }, version) {
    console.log('Upgrading application to version ' + version)
    commit('setApplicationVersion', version)
    localStorage.setItem('ApplicationVersion', version)

    setTimeout(function () {
      navigator.serviceWorker.getRegistrations()
        .then(registrations => {
          for (let registration of registrations) {
            registration.unregister()
          }
        })
    }, 250)

    setTimeout(function () {
      window.location.reload()
    }, 2000)
  }
}

// Getters
const getters = {
  getApplicationVersion: (state) => {
    return state.applicationVersion
  },
  getApplicationVersionNew: (state) => {
    return state.applicationVersionNew
  },
  getRunMode: (state) => {
    return state.runMode
  },
  getNumberOfCommandsInQueue: (state) => {
    return state.numberOfCommandsInQueue
  },
  getOldestCommandTimestamp: (state) => {
    return state.oldestCommandTimestamp
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/status.js